import { BaseError } from './BaseError';

type NetworkRequestErrorOptions = RequestInit | Record<string, string> | null;

export class NetworkRequestError extends BaseError {
    url: string;
    options: NetworkRequestErrorOptions;

    constructor(msg: string, url: string, options: NetworkRequestErrorOptions = null) {
        super(msg);

        this.url = url;
        this.options = options;

        Object.setPrototypeOf(this, NetworkRequestError.prototype);
    }
}
